import Typography from "@/src/views/components/Typography";
import ButtonBase from "@/src/views/components/Button/Button";
import style from "./style.module.scss";

type LayoutErrorProps = {
  statusCode?: number;
  onRetry?: () => void;
};

export default function LayoutError({
  statusCode,
  onRetry,
}: LayoutErrorProps) {
  const title =
    statusCode && statusCode >= 500
      ? "Terjadi Gangguan Pada Aplikasi"
      : "Halaman Sedang Tidak Dapat Dibuka";
  const description =
    "Silakan coba beberapa saat lagi. Jika masalah berlanjut, hubungi tim terkait.";

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
      return;
    }

    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    if (typeof window !== "undefined") {
      window.location.assign("/");
    }
  };

  return (
    <div
      className={`${style["grid-layout"]} ${style["grid-layout-40"]} ${style["grid-layout-container"]}`}
    >
      <div className={`${style["grid-layout"]} ${style["grid-layout-32"]}`}>
        <img
          alt="Application error"
          className={style.image}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/bg-404.webp`}
        />
        <div className={`${style["grid-layout"]} ${style["grid-layout-16"]}`}>
          <Typography variant={"heading-2-bold"} color={"gray-2"}>
            {title}
          </Typography>
          <Typography variant={"subtitle-1-medium"} color={"gray-2"}>
            {description}
          </Typography>
        </div>
      </div>

      <div className={style.actions}>
        <ButtonBase
          text={"Coba Lagi"}
          variant={"primary"}
          size={"primary"}
          enabled={true}
          onClick={handleRetry}
        />
        <ButtonBase
          text={"Ke Beranda"}
          variant={"secondary"}
          size={"primary"}
          enabled={true}
          onClick={handleGoHome}
        />
      </div>
    </div>
  );
}
